import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';


const initialState = {
    sidebarShow: true,
};

const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState,
    reducers: {
        setSidebar: (state, action) => {
            return { ...state, ...action.payload };
        },
    },
    extraReducers: (builder) => {

    }
});

export const { setSidebar } = sidebarSlice.actions;

export default sidebarSlice.reducer